// extracted by mini-css-extract-plugin
module.exports = {"avatarButton":"UserAvatar_avatarButton__1XPuf"};